<div class="mt-1">
  <p-accordion>
    <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">
      <form [formGroup]="searchForm">
        <div class="grid">
        <div class="col-12">
        <div class="p-fluid formgrid grid">
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <label>{{ 'DOImport.Table.Column.DONo' | translate }}</label>
            <p-chips formControlName="doNos" [(ngModel)]="searchParams.doNos" separator=","
              (onAdd)="doNoChipsAdd($event)"></p-chips>
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <label>{{ 'DOImport.Table.Column.Group' | translate }}</label>
            <p-chips formControlName="tenants" [(ngModel)]="searchParams.tenants" separator=","></p-chips>
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <label>{{ 'DOImport.Table.Column.LetterHeadCorp' | translate }}</label>
            <p-multiSelect [options]="letterHeadOptions" [(ngModel)]="searchParams.letterHeadOrgIds"
              formControlName="letterHeadOrgId" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              optionLabel="legalEntityOUName" optionValue="legalEntityOUCode"></p-multiSelect>
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <label>{{ 'DOImport.Table.Column.OrderCorp' | translate }}</label>
            <p-multiSelect [options]="orgIdsOptions" [(ngModel)]="searchParams.orgIds" formControlName="orgIds"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}" optionLabel="legalEntityOUName"
              optionValue="legalEntityOUCode">
            </p-multiSelect>
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <label>{{ 'DOImport.Table.Column.ShippingCorp' | translate }}</label>
            <p-multiSelect [options]="shipCorpsOptions" [(ngModel)]="searchParams.shipCorps" formControlName="shipCorps"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}" optionLabel="legalEntityOUName"
              optionValue="legalEntityOUCode"></p-multiSelect>
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <label>{{ 'DOImport.Table.Column.ConsigneeKey' | translate }}</label>
            <input pInputText type="text" formControlName="consigneeKey" [(ngModel)]="searchParams.consigneeKey" />
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <label>{{ 'DOImport.Table.Column.ConsineeName' | translate }}</label>
            <input pInputText type="text" formControlName="consigneeCompany"
              [(ngModel)]="searchParams.consigneeCompany" />
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <label>{{ 'DOImport.Table.Column.Shipterm' | translate }}</label>
            <p-dropdown appendTo="body" formControlName="incoTerm" [(ngModel)]="searchParams.incoTerm"
              [options]="incotermOptions" [showClear]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"></p-dropdown>
          </div>
          <div class="col-12 md:col-6 lg:col-3 laas-calendar">
            <laas-calendar
              #etd
              [title]="'DOImport.Table.Column.ETD'"
              [enableMaxDateIsToday]="false"
              [showRangeMode]="true"
              [showStartMode]="true"
              (onDateChange)="dateOnChange($event,'etd')">
            </laas-calendar>
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <label>{{ 'DOImport.Table.Column.DeliveryType' | translate }}</label>
            <p-dropdown formControlName="deliveryType" [options]="deliveryTypeOptions"
              [(ngModel)]="searchParams.deliveryType" [showClear]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"></p-dropdown>
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <label>{{ 'DOImport.Table.Column.DischargeType' | translate }}</label>
            <input pInputText type="text" formControlName="dischargeType" [(ngModel)]="searchParams.dischargeType" />
          </div>
          <div class="col-12 md:col-6 lg:col-3 laas-calendar">
            <laas-calendar
                  #invoiceDt
                  [title]="'DOImport.Table.Column.InvoiceTime'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event,'invoiceDt')">
              </laas-calendar>
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <label>{{ 'DOImport.Table.Column.InvoiceNumber' | translate }}</label>
            <p-chips formControlName="invoiceNos" [(ngModel)]="searchParams.invoiceNos" separator=","></p-chips>
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <label>{{ 'DOImport.Table.Column.BookingCount' | translate }}</label>
            <input pInputText type="text" formControlName="bookingCount" [(ngModel)]="searchParams.bookingCount" />
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <label>Sales code</label>
            <input pInputText type="text" formControlName="salesCode" [(ngModel)]="searchParams.salesCode" />
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <label>{{ 'DOImport.Table.Column.DoStatus' | translate }}</label>
            <p-dropdown formControlName="status" [options]="DOStatusOptions" [(ngModel)]="searchParams.status"
              [showClear]="true" placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
            </p-dropdown>
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <label>{{ 'DOImport.Table.Column.BookingStatus' | translate }}</label>
            <p-dropdown formControlName="doBookingStatus" [options]="DOBookingStatusOptions"
              [(ngModel)]="searchParams.doBookingStatus" [showClear]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
            </p-dropdown>
          </div>
          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <label>{{ 'DOImport.Table.Column.Facility' | translate }}</label>
            <p-multiSelect [options]="facilityOptions" [(ngModel)]="searchParams.selectedFacility" [ngModelOptions]="{standalone: true}"></p-multiSelect>
          </div>
        </div></div>
        <div class="col-12">
          <div class="inline-block mb-1">
            <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}"
            (click)="searchBtnClick($event)"></button>
          </div><div class="inline-block mb-1">
            <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" class="p-button-secondary ml-2"
              (click)="resetBtnClick($event)"></button>
          </div>
        </div>
      </div>
      </form>
    </p-accordionTab>
  </p-accordion>
  <div class="mt-2">
    <p-table #DODataTable laasDataTableSetting [tableKey]="preferenceKey" [defaultColumns]="columns" [value]="DORows"
      [(selection)]="selectedDORows" [loading]="isLoading" [lazy]="true" [rows]="pageInfo.pageSize" [selectable]="true"
      [totalRecords]="pageInfo.totalRecords" (onSort)="tableSort($event)" (onPage)="tablePageChange($event)"
      (setPageSize)="setPageSize($event)"
      (onRowSelect)="selectedRowsChange($event)" (onRowUnselect)="selectedRowsChange($event)" (onHeaderCheckboxToggle)="selectedRowsChange($event)" [rowsPerPageOptions]="[5,10,25,50,100,200]"
      class="datatable">
      <ng-template pTemplate="caption">
        <p-toolbar>

            <button pButton pRipple icon="fas fa-box" pTooltip="{{selectedPickingText}}"
              (click)="selectedPicking($event)"
              [ngClass]="{
                'p-button-warning': selectedPickingType == '1'
              }"></button>
              <ng-container *ngTemplateOutlet="calculateRegion"></ng-container>

        </p-toolbar>
      </ng-template>
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col style="width: 50px;">
          <col *ngFor="let col of columns" [style]="{ width: col.width + 'px' }">
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th>
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" *ngFor="let col of columns" pResizableColumn pReorderableColumn [attr.field]="col.field">
            {{col.header | translate}}
            <p-sortIcon *ngIf="col.sort" [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td>
            <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
          </td>
          <td *ngFor="let col of columns">
            <div [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'letterHeadOrgId'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping:orgOptions | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'shipCorp'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping:orgOptions | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'orgId'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping:orgOptions | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'incoTerm'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping:incoTermList | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'doStatus'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping:DOStatusOptions | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'doBookingStatus'">
                <div class="overflow-text">
                  {{ rowData[col.field] |
                  optionsMapping:DOBookingStatusOptions |
                  replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'shipNotes'">
                <div class="overflow-text">
                  {{ displayMessageArray(rowData[col.field]) | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <ng-container [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'">
                    <div class="overflow-text">
                      {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone |
                      replaceNullWith:'-' }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'array'">
                    <ng-container *ngIf="rowData[col.field].length > 0; else displayEmpty">
                      <ng-container *ngFor="let note of rowData[col.field]; index as i">
                        <div class="overflow-text">
                          {{ i + 1 }}. {{ note + '\t\n' }}
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith:'-'}}
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-template #displayEmpty>
                -
              </ng-template>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length + 1" style="text-align: center;">
            {{ 'Common.Table.NoData' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="grid mt-2">
    <div class="col text-center">
      <button pRipple pButton label="匯入勾選 DO 單號" (click)="importBtnClick($event)"></button>
    </div>
  </div>

</div>

<ng-template #calculateRegion>
  <div class="col-9 font-bold">
    {{ 'DOQuery.Form.Title.TotalCartonCnt' | translate }}：{{selectedCartonsInfo.cartonCnt}}
    {{ 'DOQuery.Form.Title.NetWeight' | translate }}：{{selectedCartonsInfo.totalNetWeight}}
    {{ 'DOQuery.Form.Title.GrossWeight' | translate }}：{{selectedCartonsInfo.totalGrossWeight}}
    {{ 'DOQuery.Form.Title.VolumeWeight' | translate }}：{{selectedCartonsInfo.volumeWeight}}
    {{ 'DOQuery.Form.Title.Cbm' | translate }}：{{selectedCartonsInfo.cbm}}
    {{ 'DOQuery.Form.Title.Pieces' | translate }}：{{selectedCartonsInfo.pieces}}
    <ng-container *ngIf="isSameCurrencyCode">
      {{ 'DOQuery.Form.Title.Price' | translate }}({{selectedCartonsInfo.currencyCode}})：{{selectedCartonsInfo.price}}
    </ng-container>
    <ng-container *ngIf="!isSameCurrencyCode">
      {{ 'DOQuery.Form.Title.Price' | translate }}：{{ 'DOQuery.Form.Title.CantShowCurrencyCode' | translate }}
    </ng-container>

  </div>
</ng-template>
